import { Edit } from '@mui/icons-material';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { IconButton, Tooltip } from '@mui/material';
import { HoverCardTranslationKeys } from 'components/common/hoverCardTranslationKeys';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React from 'react';
import { useIntl } from 'react-intl';
import { UserRole } from 'shared/types/userRole';
import { iconButtonStyle } from './styles';

export const EditUserIcon = ({
  userId,
  userRole,
}: {
  userId: string;
  userRole: UserRole;
}): React.ReactElement => {
  const intl = useIntl();
  const { canEditUser } = usePermissions();
  const { reason: disabledReason } = canEditUser(userId, userRole);
  const tooltipTitle = disabledReason
    ? formatTranslation(intl, unsafeTranslationKey(disabledReason) )
    : formatTranslation(intl, HoverCardTranslationKeys.EDIT_USER );

  // Wrapping the IconButton in a <span> allows the Tooltip to display even when the button is disabled.
  // This is necessary because disabled elements do not trigger mouse events, which Tooltip relies on.
  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton
          disabled={!!disabledReason}
          size='medium'
          sx={iconButtonStyle}
          onClick={() => {
            window.open(`/user/${userId}/edit`, '_blank');
          }}
        >
          <Edit fontSize='small' />
        </IconButton>
      </span>
    </Tooltip>
  );
};
